



































































































































import { Component, Vue } from 'vue-property-decorator';

import { PasswordInput } from '@/common/auth';
import { ErrorMessage } from '@/common/errors';
import { UserStore } from '@/store/user';

@Component({
  components: {
    ErrorMessage,
    PasswordInput,
  },
})
export default class LoginForgotPassword extends Vue {
  @UserStore.Bind.Action requestResetCode!: UserStore.Action<'requestResetCode'>;
  @UserStore.Bind.Action resendTempPassword!: UserStore.Action<'resendTempPassword'>;
  @UserStore.Bind.Action resetPassword!: UserStore.Action<'resetPassword'>;

  credentials = { username: '', verificationCode: '', newPassword: '', confirmPassword: '' };
  currentStep = 1;
  error = null;
  isResendSent = false;
  isSubmitting = false;

  get isCodeSubmitDisabled() {
    return this.isSubmitting || !(this.credentials.username.length);
  }

  get isChangePasswordDisabled() {
    return this.isSubmitting ||
           !(this.credentials.verificationCode.length) ||
           !(this.credentials.newPassword.length) ||
           (this.credentials.newPassword !== this.credentials.confirmPassword);
  }

  handleResendTemp() {
    if (this.credentials.username.length) {
      this.resendTempPassword(this.credentials.username);
      this.isResendSent = true;
    }
  }

  async handleRequestCodeClick() {
    try {
      this.isSubmitting = true;
      await this.requestResetCode(this.credentials.username);
      this.currentStep++;
    }
    catch (error) {
      this.error = error;
    }
    finally {
      this.isSubmitting = false;
    }
  }

  async handleSubmit() {
    try {
      this.isSubmitting = true;
      await this.resetPassword(this.credentials);
      this.currentStep++;
    }
    catch (error) {
      this.error = error;
    }
    finally {
      this.isSubmitting = false;
    }
  }
}
